import { Component } from '@angular/core';
import type { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { EventsService } from '@shared/services';
import { Constants } from '@shared/models';
@Component({
    'selector': 'app-notFound',
    'templateUrl': './notFound.page.html',
    'styleUrls': ['./notFound.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class NotFoundPage implements OnInit {
    constructor(private router: Router, private eventsService: EventsService) {
    }
    
    public ngOnInit(): void {
        // console.log('Not Found Page');
    }

    public onBackToPreviousClick(): void {
        this.eventsService.publish(Constants.EVENT_BACK_TO_PREVIOUS_PAGE);
    }

    public onLoginClick(): void {
        this.router.navigateByUrl('/login');
    }
}
